import React from "react";
import OrderTag from "@/enum/OrderTag";
import { OrderTagUrl } from "./util";
import { openUrl } from "@/utils";
import OrderTagNameMap from "@/map/OrderTagNameMap";

interface OrderTagWrapProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
    orderTag: OrderTag;
}

const OrderTagWrap: React.FC<OrderTagWrapProps> = (props) => {
    const { className, children, style = {}, orderTag, ...rest } = props;

    if (!orderTag) return null;
    if (!OrderTagNameMap[orderTag]) return null;

    function handleTagClick(e) {
        if (rest.onClick) {
            rest.onClick(e);
        }

        const url = OrderTagUrl[orderTag];

        if (!url) return;

        openUrl(url);
    }

    return (
        <span className={className} style={{ whiteSpace: "nowrap", ...style }} {...rest} onClick={handleTagClick}>
            {children || OrderTagNameMap[orderTag]}
        </span>
    );
};

export default React.memo(OrderTagWrap);
